export function signinRequest({ email, password }) {
  return {
    type: '@auth/SIGN_IN_REQUEST',
    payload: { email, password },
  };
}

export function singupRequest({ name, email, password }) {
  return {
    type: '@auth/SIGN_UP_REQUEST',
    payload: { name, email, password },
  };
}

export function signinSuccess(token) {
  return {
    type: '@auth/SIGN_IN_SUCCESS',
    payload: { token },
  };
}

export function signFailure() {
  return {
    type: '@auth/SIGN_FAILURE',
  };
}

export function signout() {
  return {
    type: '@auth/SIGN_OUT',
  };
}

export function resetErrors() {
  return {
    type: '@auth/RESET_ERRORS',
  };
}
